export default function PHP_fputs() {
  return (
    <div>
      <h1>PHP_fputs</h1>
    </div>
  );
}
